import * as React from "react"
import { Check, ChevronDown, ChevronsUpDown, X } from "lucide-react"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, } from "@/components/ui/command"
import { Popover, PopoverContent, PopoverTrigger, } from "@/components/ui/popover"

interface ComboboxoItem {
  value: any
  label: string
}

interface Props {
  items: ComboboxoItem[]
  className?: string
  placeholder?: string
  value?: any
  onChange?: (value: any) => void
}

export function Combobox({ items, className, placeholder, value: controlledValue, onChange }: Props) {
  const [open, setOpen] = React.useState(false)
  const [internalValue, setInternalValue] = React.useState<any>("")
  const value = controlledValue !== undefined ? controlledValue : internalValue
  const triggerRef = React.useRef<HTMLButtonElement>(null)
  const [triggerWidth, setTriggerWidth] = React.useState<number | undefined>()

  React.useEffect(() => {
    if (triggerRef.current) {
      setTriggerWidth(triggerRef.current.offsetWidth)
    }
  }, [open])


  const handleClear = (e: React.MouseEvent) => {
    e.stopPropagation()
    setInternalValue("")
    onChange?.("")
  }

  return <Popover open={open} onOpenChange={setOpen}>
    <div className="relative w-full">
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" aria-expanded={open} className={cn("w-full justify-between pr-8", className)} ref={triggerRef}>
          <span className="truncate">
            {value ? items.find((item) => item.value === value)?.label : "Select Item..."}
          </span>
          <ChevronDown className="opacity-50" />
        </Button>
      </PopoverTrigger>
      {value && (
        <button type="button" className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded" onClick={handleClear}>
          <X className="h-4 w-4 opacity-50 hover:opacity-100" />
        </button>
      )}
    </div>
    <PopoverContent className={cn("w-auto p-0")} style={{ width: triggerWidth }} >
      <Command>
        <CommandInput placeholder={placeholder || "Search Item..."} className="h-9" />
        <CommandList>
          <CommandEmpty>No items found.</CommandEmpty>
          <CommandGroup>
            {items.map((item) => (
              <CommandItem key={item.value} value={item.value} keywords={[(item.label || "").toLowerCase()]} onSelect={() => {
                const newValue = item.value === value ? "" : item.value
                setInternalValue(newValue)
                onChange?.(newValue)
                setOpen(false)
              }}>
                {item.label}
                <Check className={cn("ml-auto", value === item.value ? "opacity-100" : "opacity-0")} />
              </CommandItem>
            ))}
          </CommandGroup>
        </CommandList>
      </Command>
    </PopoverContent>
  </Popover>

}
